var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loadingx",rawName:"v-loadingx",value:(_vm.loading),expression:"loading"}],staticClass:"fm-echarts-map"})}
var staticRenderFns = []

export { render, staticRenderFns }